import clsx from 'clsx';
import React from 'react';

import { BlogType } from '@utils/types/blog';
import { BaseComponentProps } from '@utils/types/baseComponents';
import BlogListItem from '@components/blog/blogListItem';

import styles from './styles.module.scss';

type Props = {
  blogs: BlogType[];
} & BaseComponentProps;

const BlogList = (props: Props) => {
  const { containerStyle, blogs } = props;

  return (
    <div className={clsx([styles.blogList, containerStyle])}>
      {blogs.map(({ slug, ...rest }) => (
        <BlogListItem key={slug.current} slug={slug} {...rest} />
      ))}
    </div>
  );
};

export default BlogList;
